import React, { Component } from "react";
import AccountingConf from "../../../components/AccountingConf/AccountingConf";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente de Accounting con sus respectivos parámetros.
================================================================================ */

class AccountingConfForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <AccountingConf/>
        )
    }
}

export default AccountingConfForm;